<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clearToken, token } from './lib/api';

const route = useRoute();
const router = useRouter();
const isLogin = computed(() => route.path === '/login');
const authed = computed(() => !!token());

function logout() {
  clearToken();
  router.push('/login');
}
</script>

<template>
  <div class="app">
    <aside v-if="!isLogin && authed">
      <div class="brand">
        <div class="b1">WSB</div>
        <div class="b2">ADMIN</div>
      </div>
      <nav>
        <RouterLink to="/events">Events</RouterLink>
        <RouterLink to="/devices">Devices</RouterLink>
        <RouterLink to="/spins">Spin Log</RouterLink>
      </nav>
      <button class="logout btn" @click="logout">Sign Out</button>
    </aside>
    <main>
      <RouterView />
    </main>
  </div>
</template>

<style scoped>
.app {
  display: flex;
  min-height: 100vh;
}
aside {
  width: 220px;
  background: var(--dark2);
  border-right: 1px solid var(--surf3);
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.brand {
  margin-bottom: 24px;
}
.b1 {
  font-weight: 900;
  font-size: 26px;
  color: var(--or);
  letter-spacing: 3px;
}
.b2 {
  font-size: 10px;
  letter-spacing: 4px;
  color: var(--grey);
}
nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
nav a {
  padding: 10px 12px;
  border-radius: 7px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
}
nav a:hover {
  background: var(--dark3);
  color: var(--white);
}
nav a.router-link-active {
  background: var(--dark3);
  color: var(--white);
  border-left: 3px solid var(--or);
  padding-left: 9px;
}
.logout {
  margin-top: auto;
}
main {
  flex: 1;
  padding: 28px 32px;
  overflow-y: auto;
}
</style>
